import { combineReducers } from "redux";
import healthyDataReducer from "./healthyDataStore/reducer";
import recordDataReducer from "./recordDataStore/reducer";
import allDataReducer from "./allDataStore/reducer";
import globalReducer from "./globalStore/reducer";
import visionReducer from "./visionStore/reducer";
import familyHistoryReducer from "./familyhisroryStore/reducer";
import diseasesHistoryReducer from "./diseasesHistoryStore/reducer";
import allergicReducer from "./allergicStore/reducer";
import surgeryReducer from "./surgeryStore/reducer";
import otherHistoryReducer from "./otherHistoryStore/reducer";
import historyReducer from "./healthyHistoryStore/reducer";
import allVisionDataReducer from "./allVisionDataStore/reducer";
import reportReducer from "./reportStore/reducer";
import westListReducer from "./westMedicineStore/reducer"

const Reducer = combineReducers ({
  globalReducer,//全局的状态
  healthyDataReducer,//健康数据
  recordDataReducer,//添加数据
  allDataReducer,//全部数据
  visionReducer,//首页视力数据
  familyHistoryReducer,//家族健康史
  diseasesHistoryReducer,//疾病史
  allergicReducer,//过敏数据
  surgeryReducer,//手术史
  otherHistoryReducer,//烟酒史
  historyReducer,//首页历史
  allVisionDataReducer,
  reportReducer,//报告
  westListReducer,//西医报告
});

export default Reducer;
